import { graphql } from 'gatsby'

import Layout from '../components/layout'
import Seo from '../components/seo'
import SearchGrid from '../components/SearchGrid'

const SearchPage = ({data}) => {
  const { brands, models } = data;

  return (
    <Layout>
      <Seo title="Home" />
      <SearchGrid brands={brands.nodes} models={models.nodes} />
    </Layout>
  )}

export default SearchPage

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    models: allModel(filter: {active: {eq: true}}) {
      nodes {
        name
        brand {
          name
        }
      }
    }
    brands: allBrand(filter: {active: {eq: true}}) {
      nodes {
        name
      }
    }
  }
`
